import bodySvg from '!!raw-loader!./icons/body.svg';
import blocksSvg from '!!raw-loader!./icons/blocks.svg';
import contentSvg from '!!raw-loader!./icons/content.svg';
import uploadSvg from '!!raw-loader!./icons/upload.svg';
import imagesSvg from '!!raw-loader!./icons/images.svg';
import auditSvg from '!!raw-loader!./icons/audit.svg';

const convertIconToBase64 = icon => {
  return `data:image/svg+xml;base64,${btoa(icon.replaceAll('\n', ''))}`;
};

export const unlayerTabs = {
  content: {
    icon: convertIconToBase64(contentSvg),
  },
  blocks: {
    icon: convertIconToBase64(blocksSvg),
  },
  body: {
    icon: convertIconToBase64(bodySvg),
  },
  images: {
    icon: convertIconToBase64(imagesSvg),
  },
  userUploads: {
    icon: convertIconToBase64(uploadSvg),
  },
  audit: {
    icon: convertIconToBase64(auditSvg),
  },
};
